import React from 'react';
import Button from '../Button';
import { regionLabel, timeZoneFact } from '../../lib/intlOptions';
import { SETTINGS_WORDING as W, policyWord, studioCardName } from '../../domain/studioSettings';
import { LOGO_WORDING } from '../../domain/logo';
import s from './settings.module.css';

// The left-hand card on Business Settings → General.
//
// As MMS: logo, studio name, region and time zone, with an "Edit Business
// Profile" button under them; the logo large, above the name (#498). A studio
// without one shows none; what MMS's card shows in its place is unrecorded.
//
// A studio that has not named itself is shown "Your Studio" in the grey the
// rest of the placeholder text uses, because that is what its invoices and
// receipts say.

export default function StudioProfileCard({
  settings, named, onEdit, loading = false, teacherName = null,
}) {
  // Whether this row is stating the studio's zone or inferring it (#245),
  // the predicate InvoicingPanel's reminder-hours warning shares.
  const tz = timeZoneFact(settings);
  return (
    <div className={s.card}>
      {settings.logo ? <img className={s.cardLogo} src={settings.logo} alt={LOGO_WORDING.alt} /> : null}
      <div className={named ? s.studioName : s.studioNameUnset}>
        {studioCardName(settings.name)}
      </div>

      <dl className={s.facts}>
        {/* The teacher, in the Teacher Name Format (#797). MMS shows it in its
            header and account menu; AppShell's topbar carries no name. */}
        {teacherName ? (
          <>
            <dt className={s.factLabel}>{policyWord('teacherFact')}</dt>
            <dd className={s.factValue}>{teacherName}</dd>
          </>
        ) : null}

        <dt className={s.factLabel}>{W.regionFact}</dt>
        <dd className={s.factValue}>{regionLabel(settings.locale)}</dd>

        <dt className={s.factLabel}>{W.timeZoneFact}</dt>
        {/* An inferred zone is marked rather than dropped: a blank here helps
            nobody, but drawn like a stored zone it would state a guess as a
            fact and contradict the reminder-hours warning further down. */}
        <dd className={s.factValue}>
          {tz.zone || '—'}
          {tz.zone && !tz.stored ? <span className={s.factAside}> {W.thisDevice}</span> : null}
        </dd>

        {settings.phone ? (
          <>
            <dt className={s.factLabel}>{W.phoneFact}</dt>
            <dd className={s.factValue}>{settings.phone}</dd>
          </>
        ) : null}

        {settings.address ? (
          <>
            <dt className={s.factLabel}>{W.addressFact}</dt>
            <dd className={s.factAddress}>{settings.address}</dd>
          </>
        ) : null}
      </dl>

      {/* Disabled until the record has been read: the drawer commits each
          field as it is left, and opened over the defaults it would offer them
          as the studio's own values. `saveStudio` also refuses to write before
          the first snapshot, as a backstop (useSettings.jsx). */}
      <Button variant="secondary" onClick={onEdit} disabled={loading}>
        {W.editProfile}
      </Button>
    </div>
  );
}
